/* tslint:disable */

/**
 * HR Portal API
 * HR Portal API
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @interface Attachment
 */
export interface Attachment {
    /**
     *
     * @type {string}
     * @memberof Attachment
     */
    contentUrl: string;
    /**
     *
     * @type {string}
     * @memberof Attachment
     */
    fileName: string;
    /**
     *
     * @type {string}
     * @memberof Attachment
     */
    displayFileName: string;
    /**
     *
     * @type {string}
     * @memberof Attachment
     */
    contentType: string;
    /**
     *
     * @type {string}
     * @memberof Attachment
     */
    articleId: string;
}

export function AttachmentFromJSON(json: any): Attachment {
    return AttachmentFromJSONTyped(json, false);
}

export function AttachmentFromJSONTyped(json: any, _: boolean): Attachment {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'contentUrl': json['content_url'],
        'fileName': json['file_name'],
        'displayFileName': json['display_file_name'],
        'contentType': json['content_type'],
        'articleId': json['article_id'],
    };
}

export function AttachmentToJSON(value?: Attachment | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'content_url': value.contentUrl,
        'file_name': value.fileName,
        'display_file_name': value.displayFileName,
        'content_type': value.contentType,
        'article_id': value.articleId,
    };
}
